export default __webpack_public_path__ + "static/media/bridge-top-light-bg.23439c4f.svg";